var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 11.4997C13.6178 11.4997 15.3333 9.78426 15.3333 7.66634C15.3333 5.54842 13.6178 3.83301 11.4999 3.83301C9.382 3.83301 7.66659 5.54842 7.66659 7.66634C7.66659 9.78426 9.382 11.4997 11.4999 11.4997ZM11.4999 13.4163C8.94117 13.4163 3.83325 14.7005 3.83325 17.2497V19.1663H19.1666V17.2497C19.1666 14.7005 14.0587 13.4163 11.4999 13.4163Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.6173ee1909c5821bdc03cc5bd098f471.svg";
export { ForwardRef as ReactComponent };